<template>
  <div>
    <v-col cols="12" md="10">
      <v-alert
        border="left"
        colored-border
        elevation="1"
        color="telegram"
        dense
        class="rounded-lg mb-4"
        :style="styleAlert"
      >
        <div class="py-4">
          <p
            style="font-size: 17px"
            class="d-flex flex-row justify-space-between font-weight-light text-body-2"
          >
            Como pegar o código do Telegram?
          </p>
          <p class="font-weight-light text-body-2">
            Muito simples, cada pessoa tem um próprio código com o telegram,
            basta o usuário mandar qualquer mensagem para nosso bot <span class="font-weight-bold">@AlertemeBot</span>
            (Alertme.cam), clique no botão abaixo para ser redirecionado ao
            nosso Telegram ou copie o link e mande para seu usuário
          </p>
          <v-btn
            color="telegram"
            @click="openTelegram"
            dark
            style="text-transform: unset"
            class="mx-4"
          >
            <telegram-icon class="white-text" size="2.0x"></telegram-icon>
             AlerteMe Telegram</v-btn
          >
          <v-btn
            color="grey lighten-2"
            class="text-caption"
            style="text-transform: unset"
            rounded
            @click="copiarLink"
            >Clique e Copie o Link</v-btn
          >
        </div>
      </v-alert>
    </v-col>
  </div>
</template>
<script>
import { TelegramIcon } from "vue-simple-icons";
export default {
  components: { TelegramIcon },
  name: "AlertTelegram",
  data: () => ({
  }),
  computed:{
      styleAlert(){
          return {"border":"1px solid #25A3E1","border-radius":"20px"}
      }
  },
  methods: {
    openTelegram() {
      this.$alertme.openTelegram()
    },
    copiarLink() {
      navigator.clipboard.writeText(this.$alertme.getUrlTelegram()).then(
        () => {
          this.snackbar = true;
        },
        function (err) {
          console.error("Async: Could not copy text: ", err);
        }
      );
    },
  },
};
</script>